import { type ArticleGetResDTO } from "../api/article-dto.js";

export interface ArticleImage {
  id?: string;
  imageUrl: string;
  descKo: string;
  descEn: string;
  order: number;
}

export interface Author {
  id: string;
  authorName: string;
  authorEmail?: string;
  authorInsta?: string;
  authorLinkedin?: string;
  numOfArticles?: number;
  createdAt?: string;
  updatedAt?: string;
}

export interface KeywordOnArticle {
  id: string;
  nameKo: string;
  nameEn?: string;
  descKo: string;
  descEn: string;
  categoryId: string;
  categoryNameKo: string;
  categoryNameEn?: string;
  studyLinks?: string[];
  numOfArticles?: number;
  createdAt?: string;
  updatedAt?: string;
}

export interface Product {
  id: string;
  nameKo: string;
  nameEn?: string;
  imageUrl?: string;
  numOfArticles?: number;
  createdAt?: string;
  updatedAt?: string;
}

export interface Article {
  id: string;
  titleKo: string;
  titleEn?: string;
  contentKo: string;
  contentEn?: string;
  uxEvaluation: string;
  dataSource: string;
  studyLinks: string[];
  createdAt: string;
  updatedAt: string;

  // 관계형 데이터
  authorId?: string;
  author: Author;
  keywordId?: string;
  keyword: KeywordOnArticle;
  productId?: string;
  product?: Product;
  images: ArticleImage[];
}

export interface UxEvaluationCount {
  goodUxCount: number;
  badUxCount: number;
}

export const toArticle = (dto: ArticleGetResDTO): Article => {
  return {
    id: dto.id,
    titleKo: dto.titleKo,
    titleEn: dto.titleEn,
    contentKo: dto.contentKo,
    contentEn: dto.contentEn,
    uxEvaluation: dto.uxEvaluation,
    dataSource: dto.dataSource || "CUSTOM",
    studyLinks: dto.studyLinks,
    createdAt: dto.created_at,
    updatedAt: dto.updated_at,
    author: {
      id: dto.author?.id || "",
      authorName: dto.author?.name || "",
      authorEmail: dto.author?.email || "",
      authorInsta: dto.author?.instagram || "",
      authorLinkedin: dto.author?.linkedin || "",
    },
    keyword: {
      id: dto.keyword.id,
      nameKo: dto.keyword.nameKo,
      nameEn: dto.keyword.nameEn,
      descKo: dto.keyword.descKo,
      descEn: dto.keyword.descEn,
      categoryId: dto.keyword.categoryId,
      categoryNameKo: dto.keyword.categoryNameKo,
      categoryNameEn: dto.keyword.categoryNameEn,
    },
    product: {
      id: dto.product.id,
      nameKo: dto.product.nameKo,
      nameEn: dto.product.nameEn,
      imageUrl: dto.product.imageUrl,
    },
    images:
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      dto.images?.map((img: any) => ({
        imageUrl: img.imageUrl,
        descKo: img.descKo,
        descEn: img.descEn,
        order: img.order,
      })) || [],
  };
};
